import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { PATHS } from './constant';
import { Can, useCan } from '../../features/user/Can';
import { FeatureFlag } from '../../features/user/Permission';
import VehicleCompatibilitySearch from './VehicleCompatibilitySearch';
import { NoAccessBody } from '../NoAccess';
import VehicleModelForm from './VehicleModelForm';
import VehicleModelGroupForm from './VehicleModelGroupForm';
import VehicleCompatibility from './VehicleCompatibility';
import { useDispatch, useSelector } from 'react-redux';

const VehicleCompatibilityRouter = () => {
	const searchObj = useSelector(state => state.vehicleModelFilter.searchFilter);
	const isSearched = ((searchObj?.make|| []).length !== 0 || (searchObj?.model|| []).length !== 0 || !!searchObj?.q) && searchObj?.time === undefined;

	return (
		<Can onFail={<NoAccessBody />}>
			<Switch>
				<Route path={PATHS.VEHICLE_MODEL}>
					<Can onFail={<NoAccessBody />}>
						<VehicleModelForm />
					</Can>
				</Route>
				<Route path={PATHS.VEHICLE_MODEL_GROUP}>
					<Can onFail={<NoAccessBody />}>
						<VehicleModelGroupForm />
					</Can>
				</Route>
				<Route path={PATHS.VEHICLE_COMPATIBILITY}>
					<VehicleCompatibility />
				</Route>
				<Route path={PATHS.VEHICLE_COMPATIBILITY_DEFAULT}>
					{isSearched ? <VehicleCompatibility /> : <VehicleCompatibilitySearch />}
				</Route>
			</Switch>
		</Can>
	);
};

export default VehicleCompatibilityRouter;
